import auditService from 'resources/audit/audit.service';


const updateAuditsByDiff = async (auditsDiff) => {
  const { added: auditsToAdd, updated: auditsToUpdate, deleted: auditsToDelete } = auditsDiff;

  const addPromises = Promise.all(
    Object.entries(auditsToAdd).map(([auditId, auditData]) => (
      auditService.createAudit({
        id: auditId,
        companyId: auditData.company_id,
        name: auditData.name,
        type: auditData.type,
        listedkitId: auditData.listedkit_id,
        dueInDays: auditData.due_in_days,
        isAfterAction: auditData.is_after_action,
        dueRelativeDate: auditData.due_relative_date,
      })
    )) || [],
  );

  const updatePromises = Promise.all(
    Object.entries(auditsToUpdate).map(([auditId, auditData]) =>
      auditService.updateOne({ id: auditId }, auditData)
    ) || [],
  );

  const deletePromises = Promise.all(
    Object.keys(auditsToDelete).map((auditId) =>
      auditService.removeAudit(auditId)
    ) || [],
  );

  const [created, updated, deleted] = await Promise.all([addPromises, updatePromises, deletePromises]);

  return { created, updated, deleted };
};

export { updateAuditsByDiff };
